export default __webpack_public_path__ + "static/media/achat.d0388bb5.jpg";